module.exports = __webpack_public_path__ + "img/2_1.4a7e6138.png";